import UsersTable from "../users_table/index";
import UsersCard from "../users_cards";
import { MainContainer, ContentWrapper } from "./styles";
import { motion } from "framer-motion";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { appStatus } from "../../store/modules/app_status/actions";
import { userService } from "../../services/userService";
import { userRequestService } from "../../services/userRequestService";
import UserResquestTable from "../guardian/GuardianUser/UserRequestTable/UserRequestTable";
import PageHeader from "../page_header";
import {
  canAccessUsersPanel,
  canCreateFieldUsers,
  canManageUsers,
  filterUsersForViewer,
  isEngineeringUser,
} from "../../utils/userRoles";

const ADM_USER_TABS = [
  { id: "users", label: "Usuários do sistema" },
  { id: "requests", label: "Solicitações de usuário" },
];

const USER_SEARCH_COLUMNS = [
  { value: "Nome", label: "Nome" },
  { value: "Email", label: "Email" },
  { value: "Whatsapp", label: "Whatsapp" },
  { value: "Localidade", label: "Localidade" },
  { value: "Acesso", label: "Acesso" },
];

const Users = () => {
  const location = useLocation();
  const app_status = useSelector((state) => state.app_status.status);
  const layoutUsers = useSelector((state) => state.layout.cardsLayoutUsers);
  const currentUser = useSelector((state) => state.user.currentUser);

  const isEngOnly = isEngineeringUser(currentUser) && !canManageUsers(currentUser);
  const userTabs = ADM_USER_TABS;

  const initialTab = location.state?.activeTab || "users";
  const [activeTab, setActiveTab] = useState(initialTab);

  const [selectedColumn, setSelectedColumn] = useState("Nome");
  const [searchValue, setSearchValue] = useState("");
  const [users, setUsers] = useState([]);
  const [userRequests, setUserRequests] = useState([]);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!canAccessUsersPanel(currentUser)) {
      navigate("/dashboard", { replace: true });
    }
  }, [currentUser, navigate]);

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const usersRes = await userService.getUsers();
        const usersArray = Array.isArray(usersRes)
          ? usersRes
          : usersRes.data || [];
        setUsers(filterUsersForViewer(usersArray, currentUser));
      } catch (error) {
        console.error("Erro ao buscar usuários:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, [app_status, currentUser]);

  const fetchUserRequests = async () => {
    try {
      setLoadingRequests(true);

      const response = await userRequestService.getUserRequests({
        status: "PENDENTE",
      });

      if (response?.success) {
        setUserRequests(response.data || []);
      } else {
        setUserRequests([]);
      }
    } catch (error) {
      console.error("Erro ao buscar solicitações de usuário:", error);
      setUserRequests([]);
    } finally {
      setLoadingRequests(false);
    }
  };

  useEffect(() => {
    if (activeTab === "requests") {
      fetchUserRequests();
    }
  }, [activeTab]);

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      if (!searchValue) return true;
      const q = searchValue.toLowerCase();
      if (selectedColumn === "Nome") {
        return (user.full_name || "").toLowerCase().includes(q);
      }
      if (selectedColumn === "Email") {
        return (user.email || "").toLowerCase().includes(q);
      }
      if (selectedColumn === "Whatsapp") {
        return (user.phone || "").toLowerCase().includes(q);
      }
      if (selectedColumn === "Localidade") {
        return `${user.city || ""}, ${user.state || ""}`.toLowerCase().includes(q);
      }
      if (selectedColumn === "Acesso") {
        return (user.user_type || "").toLowerCase().includes(q);
      }
      return false;
    });
  }, [users, searchValue, selectedColumn]);

  const handleClick = () => {
    dispatch(appStatus("cad_new_user"));
    navigate("/welcome", {
      state: { simplifiedFieldUser: isEngOnly },
    });
  };

  const showUsersSearch = activeTab === "users";
  const showAddButton = canCreateFieldUsers(currentUser);

  return (
    <MainContainer>
      <ContentWrapper>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        />

        <PageHeader
          title="Usuários"
          actionLabel={showAddButton ? "Adicionar Usuário" : null}
          onAction={showAddButton ? handleClick : undefined}
          tabs={userTabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          search={
            showUsersSearch
              ? {
                  columns: USER_SEARCH_COLUMNS,
                  selectedColumn,
                  onColumnChange: (e) => setSelectedColumn(e.target.value),
                  searchValue,
                  onSearchChange: (e) => setSearchValue(e.target.value),
                }
              : null
          }
        />

        {activeTab === "users" ? (
          layoutUsers ? (
            <UsersCard filteredUsers={filteredUsers} />
          ) : (
            <UsersTable filteredUsers={filteredUsers} />
          )
        ) : loadingRequests ? (
          <div style={{ color: "var(--text-heading)" }}>
            Carregando solicitações...
          </div>
        ) : (
          <UserResquestTable
            filteredUsers={userRequests}
            onUserUpdate={fetchUserRequests}
          />
        )}
      </ContentWrapper>
    </MainContainer>
  );
};

export default Users;
